import { AxiosInstance } from 'axios';

import { MESSAGE_URLS } from '@/constants/urls';
import { ENTITY_TYPE, MessageChat } from '@/model/General/MessageChat';

class MessageChatApi {
  axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  async getMessages(entityType: ENTITY_TYPE, entityId: number) {
    try {
      const response = await this.axiosInstance.get(MESSAGE_URLS.MESSAGES, {
        params: { entity_type: entityType, entity_id: entityId },
      });

      return response.data;
    } catch (error) {
      console.error('Error fetching messages:', error);
      throw error;
    }
  }

  async postMessage(message: MessageChat) {
    try {
      const response = await this.axiosInstance.post(MESSAGE_URLS.MESSAGES, message);

      return response.data;
    } catch (error) {
      console.error('Error posting message:', error);
      throw error;
    }
  }
}

export default MessageChatApi;
